import { render, staticRenderFns } from "./WatchLinkedUrl.vue?vue&type=template&id=fbba1f58&scoped=true"
import script from "./WatchLinkedUrl.vue?vue&type=script&lang=js"
export * from "./WatchLinkedUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbba1f58",
  null
  
)

export default component.exports